export const ButtonAdd    = 'add';
export const ButtonReload = 'reload';